export class MenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [
        {
          title: 'Trang chủ',
          page: '/homepage'
        },

        {
          title: 'Tìm phụ tùng',
          page: '/app-mobile'
        },

        {
          title: 'Danh mục',
          page: '/device-block'
        },

        // {
        // 	title: 'Về chúng tôi',
        // 	page: '/user-management'
        // },
        // {
        // 	title: 'DS khách lấy báo giá',
        // 	page: '/admin/quote-management'
        // },

        {
          title: 'Liên hệ',
          page: '/contact'
        }
      ]
    },
    aside: {
      self: {},
      items: [
        {
          title: 'Trang chủ',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: '',
          translate: 'MENU.DASHBOARD',
          bullet: 'dot',
          show: true
        },
        {
          title: 'Dashboard',
          root: true,
          icon: 'flaticon2-pie-chart-1',
          page: '/admin/dashboard'
        },
        {
          title: 'Quản lý đơn hàng',
          root: true,
          icon: 'flaticon-layer',
          page: '/admin/order-management',
          badge: {
            type: 'kt-badge--danger',
            value: '0'
          }
        },
        // {
        //   title: 'Tạo đơn hàng cho khách',
        //   root: true,
        //   icon: 'flaticon-add',
        //   page: '/admin/create-order-for-customer',
        // },
        {
          title: 'Quản lý chính sách',
          root: true,
          icon: 'flaticon-layer',
          page: '/admin/posts'
        },
        {
          title: 'Quản lý Blog',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-writing',
          submenu: [
            {
              title: 'Bài viết',
              icon: '',
              page: '/admin/blog-management/posts'
            },
            {
              title: 'Danh mục',
              icon: '',
              page: '/admin/blog-management/categories'
            },
            {
              title: 'Thẻ',
              icon: '',
              page: '/admin/blog-management/tags'
            }
          ]
        },
        {
          title: 'Quản lý Liên hệ',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-phone',
          submenu: [
            {
              title: 'Phòng ban / Tabs',
              icon: '',
              page: '/admin/contact-management/departments'
            },
            {
              title: 'Nhân sự liên hệ',
              icon: '',
              page: '/admin/contact-management/persons'
            },
            {
              title: 'Thư liên hệ',
              icon: '',
              page: '/admin/contact-management/inquiries'
            }
          ]
        },
        {
          title: 'Quản lý sản phẩm',
          root: true,
          icon: 'flaticon-layer',
          page: '/admin/product-management'
        },
        {
          title: 'Quản lý VAT',
          root: true,
          icon: 'flaticon2-shelter',
          page: '/admin/vat-config'
        },
        {
          title: 'Quản lý kho hàng',
          root: true,
          icon: 'flaticon2-shelter',
          page: '/admin/warehouse-management'
        },
        {
          title: 'Quản lý nhà sản xuất',
          root: true,
          icon: 'flaticon2-shelter',
          page: '/admin/producer-management'
        },
        {
          title: 'Quản lý bán hàng',
          root: true,
          bullet: 'dot',
          icon: 'flaticon-layer',
          submenu: [
            {
              title: 'Quản lý người dùng',
              icon: 'flaticon2-user-outline-symbol',
              page: '/admin/manage-users'
            },
            {
              title: 'Quản lý báo giá',
              icon: 'flaticon2-writing',
              page: '/admin/quote-management'
            },
            {
              title: 'Quản lý mã giảm giá',
              icon: 'flaticon-interface-9',
              page: '/admin/manage-vouchers'
            },
            {
              title: 'Theo dõi hành vi',
              icon: 'flaticon2-analytics-2',
              page: '/admin/user-tracking'
            }
          ]
        },
        {
          title: 'Quản lý file',
          root: true,
          icon: 'flaticon2-writing',
          page: '/admin/attachment-management'
        },
        {
          title: 'Quản lý thiết bị',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-browser-2',
          submenu: [
            {
              title: 'Thống kê thiết bị',
              icon: 'flaticon2-analytics-2',
              page: '/admin/equipment-statistics'
            },
            
            {
              title: 'Thiết bị của người dùng',
              icon: 'flaticon-truck',
              page: '/admin/my-equipment-management'
            },

            {
              title: 'Loại thiết bị',
              icon: '',
              page: '/admin/equipment-type-management'
            },
            {
              title: 'Model thiết bị',
              icon: '',
              page: '/admin/equipment-model-management'
            },
            // {
            //   title: 'Sản phẩm tương thích',
            //   icon: '',
            //   page: '/admin/compatible-product-management',
            // },
            {
              title: 'Gói phụ tùng',
              icon: '',
              page: '/admin/part-package-management'
            }
          ]
        },
        {
          title: 'Quản lý trang chủ',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-architecture-and-city',
          submenu: [
            {
              title: 'Quản lý chính sách',
              icon: 'flaticon-layer',
              page: '/admin/posts'
            },
            {
              title: 'Quản lý danh mục',
              icon: 'flaticon2-indent-dots',
              page: '/admin/catalog-management'
            },
            {
              title: 'Quản lý hãng',
              icon: 'flaticon2-setup',
              page: '/admin/brand-management'
            },
            {
              title: 'Quản lý Deals',
              icon: '',
              page: '/admin/deals-management'
            },
            {
              title: 'Quản lý logo hãng',
              icon: '',
              page: '/admin/brand-logo-management'
            },
            {
              title: 'Quản lý Promo Banner',
              icon: '',
              page: '/admin/promo-banner-management'
            },
            {
              title: 'Quản lý chung',
              icon: '',
              page: '/admin/general-settings'
            },
            {
              title: 'Quản lý Footer',
              icon: '',
              page: '/admin/footer-management'
            },
            {
              title: 'Quản lý Về chúng tôi',
              icon: '',
              page: '/admin/about-us-management'
            }
          ]
        },
        {
          title: 'Danh mục Công nợ',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-calendar-8',
          submenu: [
            {
              title: 'Tổng quan công nợ',
              page: '/admin/debt-summary'
            },
            {
              title: 'Quản lý công nợ',
              page: '/admin/unpaid-orders-management'
            },
            {
              title: 'Cấu hình công nợ',
              page: '/admin/debt-reminder-config'
            }
          ]
        }

        // { section: 'Components' },
        // {
        // 	title: 'Google Material',
        // 	root: true,
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-browser-2',
        // 	submenu: [
        // 		{
        // 			title: 'Form Controls',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Auto Complete',
        // 					page: '/material/form-controls/autocomplete',
        // 					permission: 'accessToECommerceModule'
        // 				},
        // 				{
        // 					title: 'Checkbox',
        // 					page: '/material/form-controls/checkbox'
        // 				},
        // 				{
        // 					title: 'Radio Button',
        // 					page: '/material/form-controls/radiobutton'
        // 				},
        // 				{
        // 					title: 'Datepicker',
        // 					page: '/material/form-controls/datepicker'
        // 				},
        // 				{
        // 					title: 'Form Field',
        // 					page: '/material/form-controls/formfield'
        // 				},
        // 				{
        // 					title: 'Input',
        // 					page: '/material/form-controls/input'
        // 				},
        // 				{
        // 					title: 'Select',
        // 					page: '/material/form-controls/select'
        // 				},
        // 				{
        // 					title: 'Slider',
        // 					page: '/material/form-controls/slider'
        // 				},
        // 				{
        // 					title: 'Slider Toggle',
        // 					page: '/material/form-controls/slidertoggle'
        // 				}
        // 			]
        // 		},
        // 		{
        // 			title: 'Navigation',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Menu',
        // 					page: '/material/navigation/menu'
        // 				},
        // 				{
        // 					title: 'Sidenav',
        // 					page: '/material/navigation/sidenav'
        // 				},
        // 				{
        // 					title: 'Toolbar',
        // 					page: '/material/navigation/toolbar'
        // 				}
        // 			]
        // 		},
        // 		{
        // 			title: 'Layout',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Card',
        // 					page: '/material/layout/card'
        // 				},
        // 				{
        // 					title: 'Divider',
        // 					page: '/material/layout/divider'
        // 				},
        // 				{
        // 					title: 'Expansion panel',
        // 					page: '/material/layout/expansion-panel'
        // 				},
        // 				{
        // 					title: 'Grid list',
        // 					page: '/material/layout/grid-list'
        // 				},
        // 				{
        // 					title: 'List',
        // 					page: '/material/layout/list'
        // 				},
        // 				{
        // 					title: 'Tabs',
        // 					page: '/material/layout/tabs'
        // 				},
        // 				{
        // 					title: 'Stepper',
        // 					page: '/material/layout/stepper'
        // 				},
        // 				{
        // 					title: 'Default Forms',
        // 					page: '/material/layout/default-forms'
        // 				},
        // 				{
        // 					title: 'Tree',
        // 					page: '/material/layout/tree'
        // 				}
        // 			]
        // 		},
        // 		{
        // 			title: 'Buttons & Indicators',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Button',
        // 					page: '/material/buttons-and-indicators/button'
        // 				},
        // 				{
        // 					title: 'Button toggle',
        // 					page: '/material/buttons-and-indicators/button-toggle'
        // 				},
        // 				{
        // 					title: 'Chips',
        // 					page: '/material/buttons-and-indicators/chips'
        // 				},
        // 				{
        // 					title: 'Icon',
        // 					page: '/material/buttons-and-indicators/icon'
        // 				},
        // 				{
        // 					title: 'Progress bar',
        // 					page: '/material/buttons-and-indicators/progress-bar'
        // 				},
        // 				{
        // 					title: 'Progress spinner',
        // 					page: '/material/buttons-and-indicators/progress-spinner'
        // 				},
        // 				{
        // 					title: 'Ripples',
        // 					page: '/material/buttons-and-indicators/ripples'
        // 				}
        // 			]
        // 		},
        // 		{
        // 			title: 'Popups & Modals',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Bottom sheet',
        // 					page: '/material/popups-and-modals/bottom-sheet'
        // 				},
        // 				{
        // 					title: 'Dialog',
        // 					page: '/material/popups-and-modals/dialog'
        // 				},
        // 				{
        // 					title: 'Snackbar',
        // 					page: '/material/popups-and-modals/snackbar'
        // 				},
        // 				{
        // 					title: 'Tooltip',
        // 					page: '/material/popups-and-modals/tooltip'
        // 				}
        // 			]
        // 		},
        // 		{
        // 			title: 'Data table',
        // 			bullet: 'dot',
        // 			submenu: [
        // 				{
        // 					title: 'Paginator',
        // 					page: '/material/data-table/paginator'
        // 				},
        // 				{
        // 					title: 'Sort header',
        // 					page: '/material/data-table/sort-header'
        // 				},
        // 				{
        // 					title: 'Table',
        // 					page: '/material/data-table/table'
        // 				}
        // 			]
        // 		}
        // 	]
        // },
        // {
        // 	title: 'Ng-Bootstrap',
        // 	root: true,
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-digital-marketing',
        // 	submenu: [
        // 		{
        // 			title: 'Accordion',
        // 			page: '/ngbootstrap/accordion'
        // 		},
        // 		{
        // 			title: 'Alert',
        // 			page: '/ngbootstrap/alert'
        // 		},
        // 		{
        // 			title: 'Buttons',
        // 			page: '/ngbootstrap/buttons'
        // 		},
        // 		{
        // 			title: 'Carousel',
        // 			page: '/ngbootstrap/carousel'
        // 		},
        // 		{
        // 			title: 'Collapse',
        // 			page: '/ngbootstrap/collapse'
        // 		},
        // 		{
        // 			title: 'Datepicker',
        // 			page: '/ngbootstrap/datepicker'
        // 		},
        // 		{
        // 			title: 'Dropdown',
        // 			page: '/ngbootstrap/dropdown'
        // 		},
        // 		{
        // 			title: 'Modal',
        // 			page: '/ngbootstrap/modal'
        // 		},
        // 		{
        // 			title: 'Pagination',
        // 			page: '/ngbootstrap/pagination'
        // 		},
        // 		{
        // 			title: 'Popover',
        // 			page: '/ngbootstrap/popover'
        // 		},
        // 		{
        // 			title: 'Progressbar',
        // 			page: '/ngbootstrap/progressbar'
        // 		},
        // 		{
        // 			title: 'Rating',
        // 			page: '/ngbootstrap/rating'
        // 		},
        // 		{
        // 			title: 'Tabs',
        // 			page: '/ngbootstrap/tabs'
        // 		},
        // 		{
        // 			title: 'Timepicker',
        // 			page: '/ngbootstrap/timepicker'
        // 		},
        // 		{
        // 			title: 'Tooltips',
        // 			page: '/ngbootstrap/tooltip'
        // 		},
        // 		{
        // 			title: 'Typehead',
        // 			page: '/ngbootstrap/typehead'
        // 		}
        // 	]
        // },
        // { section: 'Applications' },
        // {
        // 	title: 'eCommerce',
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-list-2',
        // 	root: true,
        // 	permission: 'accessToECommerceModule',
        // 	submenu: [
        // 		{
        // 			title: 'Customers',
        // 			page: '/ecommerce/customers'
        // 		},
        // 		{
        // 			title: 'Products',
        // 			page: '/ecommerce/products'
        // 		},
        // 	]
        // },
        // {
        // 	title: 'User Management',
        // 	root: true,
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-user-outline-symbol',
        // 	submenu: [
        // 		{
        // 			title: 'Users',
        // 			page: '/user-management/users'
        // 		},
        // 		{
        // 			title: 'Roles',
        // 			page: '/user-management/roles'
        // 		}
        // 	]
        // },
        // { section: 'Custom' },
        // {
        // 	title: 'Error Pages',
        // 	root: true,
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-list-2',
        // 	submenu: [
        // 		{
        // 			title: 'Error 1',
        // 			page: '/error/error-v1'
        // 		},
        // 		{
        // 			title: 'Error 2',
        // 			page: '/error/error-v2'
        // 		},
        // 		{
        // 			title: 'Error 3',
        // 			page: '/error/error-v3'
        // 		},
        // 		{
        // 			title: 'Error 4',
        // 			page: '/error/error-v4'
        // 		},
        // 		{
        // 			title: 'Error 5',
        // 			page: '/error/error-v5'
        // 		},
        // 		{
        // 			title: 'Error 6',
        // 			page: '/error/error-v6'
        // 		},
        // 	]
        // },
        // {
        // 	title: 'Wizard',
        // 	root: true,
        // 	bullet: 'dot',
        // 	icon: 'flaticon2-mail-1',
        // 	submenu: [
        // 		{
        // 			title: 'Wizard 1',
        // 			page: '/wizard/wizard-1'
        // 		},
        // 		{
        // 			title: 'Wizard 2',
        // 			page: '/wizard/wizard-2'
        // 		},
        // 		{
        // 			title: 'Wizard 3',
        // 			page: '/wizard/wizard-3'
        // 		},
        // 		{
        // 			title: 'Wizard 4',
        // 			page: '/wizard/wizard-4'
        // 		},
        // 	]
        // },
      ]
    }
  };

  public get configs(): any {
    return this.defaults;
  }
  public getMenuHeader() {
    return this.defaults.header.items;
  }
}
